import schedule from '../images/internShips/slider_icon_1.svg'
import home from '../images/internShips/slider_icon_2.svg'
import plus from '../images/internShips/slider_icon_3.svg'
import vector from '../images/internShips/slider_icon_4.svg'
import vector2 from '../images/internShips/slider_icon_5.svg'

export const internShipsSliderInformation = [
  {
    id: 1,
    title: 'Качественное образование',
    img: schedule,
    text: 'Насыщенная стажерская программа'
  },
  {
    id: 2,
    title: 'Работа с наставником',
    img: home,
    text: 'Обучение в сопровождении ведущих экспертов компании'
  },
  {
    id: 3,
    title: 'Непрерывная практика',
    img: plus,
    text: 'Реальные задачи с погружением в профессиональную среду'
  },
  {
    id: 4,
    title: 'Уникальные навыки',
    img: vector,
    text: 'Обучение на высокотехнологичном лабораторном оборудовании'
  },
  {
    id: 5,
    title: 'Старт карьеры в Generium',
    img: vector2,
    text: 'При успешном завершении стажировки можно продолжить карьеру в компании'
  }
]
